import React, { useState } from "react";
import PropTypes from "prop-types";
import { Segment, Header, Button } from "semantic-ui-react";
import ShareButton from "../ShareButton";
import { Document, Page, pdfjs } from "react-pdf";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
const Stats = ({
  totalQuestions,
  resultType,
  resultName,
  replayQuiz,
  resetQuiz,
  userInfo,
}) => {
  const filePath = `${process.env.PUBLIC_URL}/pdfs/${resultType.toLowerCase().replace(/\s/g, "")}.pdf`;
  const [personalizedPdfUrl, setPersonalizedPdfUrl] = useState(null);

  const generatePersonalizedPdf = async (userInfo) => {
    const { full_name, email, company, role } = userInfo;

    const existingPdfBytes = await fetch(filePath).then((res) =>
      res.arrayBuffer(),
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const coverPdf = await PDFDocument.create();
    coverPdf.registerFontkit(fontkit);
    const page = coverPdf.addPage([595.28, 841.89]); // A4

    // PNG görseli ekle
    const imageBytes = await fetch(`${process.env.PUBLIC_URL}/kapak.png`).then(
      (res) => res.arrayBuffer(),
    );
    const pngImage = await coverPdf.embedPng(imageBytes);
    const pngDims = pngImage.scale(1);

    // PNG'yi sayfanın üstüne, oranı bozmadan yerleştir
    const maxWidth = 595.28;
    const scaled = pngImage.scale(maxWidth / pngDims.width);
    const imageHeight = scaled.height;

    page.drawImage(pngImage, {
      x: 0,
      y: 841.89 - imageHeight,
      width: maxWidth,
      height: imageHeight,
    });

    // Font ve yazılar (Türkçe karakterler için Roboto embed ediliyor)
    const fontBytes = await fetch(
      `${process.env.PUBLIC_URL}/fonts/custom/Roboto-Regular.ttf`,
    ).then((res) => res.arrayBuffer());
    const font = await coverPdf.embedFont(fontBytes);
    const textSize = 16;
    const textGap = 30;
    const centerX = 300;
    const texts = [
      `Ad Soyad: ${full_name ?? ""}`,
      `Email: ${email ?? ""}`,
      `Sirket: ${company ?? ""}`,
      `Pozisyon: ${role ?? ""}`,
    ];

    const startY = (841.89 - imageHeight) / 2 + (texts.length * textGap) / 2;

    const title = "Quders Q-Test Raporu";
    const titleSize = 26;
    const titleWidth = font.widthOfTextAtSize(title, titleSize);

    // Başlık, bilgilerden yukarıda ama kapak görselinin altına taşmamalı
    page.drawText(title, {
      x: centerX - titleWidth / 2,
      y: startY + textGap + 10, // Bilgi satırlarının üstü + biraz boşluk
      size: titleSize,
      font,
      color: rgb(0, 0.2, 0.5),
    });

    texts.forEach((text, i) => {
      const y = startY - i * textGap;
      const textWidth = font.widthOfTextAtSize(text, 16);
      page.drawText(text, {
        x: centerX - textWidth / 2,
        y,
        size: 16,
        font,
        color: rgb(0.1, 0.1, 0.1),
      });
    });
    // PDF birleştir
    const finalPdf = await PDFDocument.create();
    const [coverPage] = await finalPdf.copyPages(coverPdf, [0]);
    finalPdf.addPage(coverPage);

    const copiedPages = await finalPdf.copyPages(
      pdfDoc,
      pdfDoc.getPageIndices(),
    );
    copiedPages.forEach((p) => finalPdf.addPage(p));

    const pdfBytes = await finalPdf.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setPersonalizedPdfUrl(url);

    const a = document.createElement("a");
    a.href = url;
    a.download = `KisiselTestSonucu.pdf`;
    a.click();
  };

  return (
    <Segment>
      <Header as="h1" textAlign="center" block>
        Kişilik Analizi Sonucu:
      </Header>
      <Header as="h2" textAlign="center" color="teal">
        {resultName}
      </Header>
      <Header
        as="h4"
        textAlign="center"
        style={{ color: "gray", marginTop: "-10px" }}
      >
        Sonucunuz {userInfo.email} adresine mail olarak gönderilmiştir.
      </Header>
      <Header textAlign="center" block>
        <Button
          icon="download"
          content="Kişisel PDF İndir"
          color="blue"
          onClick={() => generatePersonalizedPdf(userInfo)}
        />
      </Header>
      {/* <Header as="h3" textAlign="center" block>
        Toplam Soru Seti Sayısı: {totalQuestions}
      </Header> */}

      {/* İstersen burada personality type açıklaması da gösterilebilir */}

      <div style={{ marginTop: 35 }}>
        {/* <Button
          primary
          content="Tekrar Başla"
          onClick={replayQuiz}
          size="big"
          icon="redo"
          labelPosition="left"
          style={{ marginRight: 15, marginBottom: 8 }}
        /> */}
        <Button
          color="teal"
          content="Anasayfa"
          onClick={resetQuiz}
          size="big"
          icon="home"
          labelPosition="left"
          style={{ marginBottom: 8 }}
        />
        {/* <ShareButton /> */}
      </div>
    </Segment>
  );
};

Stats.propTypes = {
  totalQuestions: PropTypes.number.isRequired,
  resultType: PropTypes.string.isRequired,
  replayQuiz: PropTypes.func.isRequired,
  resetQuiz: PropTypes.func.isRequired,
};

export default Stats;
